export const knowledgeBase = [
    // --- Pricing & Costs ---
    {
        category: "Pricing",
        keywords: ["cost", "price", "pricing", "money", "expensive", "quote", "rate", "budget", "how much"],
        response: "Our pricing is flexible! Starter plans typically begin at $15k - $25k, depending on complexity. We offer both fixed-price and time-and-materials models. Would you like a detailed quote for your specific idea?",
        link: "/pricing",
        linkText: "View Pricing Details"
    },
    {
        category: "Pricing",
        keywords: ["payment", "billing", "invoice", "terms"],
        response: "We usually structure payments in milestones: a deposit to start, followed by payments upon completion of key deliverables. We can review this structure during our initial consultation."
    },

    // --- Services & Tech ---
    {
        category: "Services",
        keywords: ["service", "offer", "perform", "do you do", "capabilities", "specializ", "build"],
        response: "We specialize in end-to-end development: iOS & Android native apps, AI/Machine Learning integration, Robotics software, and backend architecture. We handle everything from design to App Store launch.",
        link: "/services",
        linkText: "Explore Services"
    },
    {
        category: "Tech Stack",
        keywords: ["tech", "stack", "language", "swift", "react", "python", "framework"],
        response: "We use top-tier modern tech: Swift (iOS), Kotlin (Android), React/OCaml (Web), and Python (AI/Backend). This ensures your app is fast, scalable, and future-proof."
    },
    {
        category: "AI",
        keywords: ["ai", "machine learning", "robotics", "intelligence", "ml"],
        response: "Yes! We have deep expertise in integrating AI and Machine Learning models into mobile and web applications to create smarter, predictive user experiences."
    },

    // --- Process & Timeline ---
    {
        category: "Process",
        keywords: ["process", "step", "workflow", "how it works", "methodology", "agile", "scrum"],
        response: "We follow an Agile methodology. We work in 2-week sprints, giving you regular updates and a playable build at the end of every cycle. You're involved every step of the way!"
    },
    {
        category: "Timeline",
        keywords: ["time", "long", "duration", "timeline", "schedule", "when", "finish"],
        response: "A typical MVP (Minimum Viable Product) takes about 8-12 weeks. larger or more complex enterprise projects can take 4-6 months. We'll give you a precise timeline after discussing your requirements."
    },

    // --- Maintenance & Support ---
    {
        category: "Support",
        keywords: ["support", "maintain", "maintenance", "update", "bug", "fix", "after", "launch"],
        response: "We don't just leave you hanging! We offer ongoing maintenance packages to handle iOS updates, server monitoring, and feature enhancements after launch."
    },

    // --- Legal & IP ---
    {
        category: "Legal",
        keywords: ["own", "ownership", "code", "intellectual property", "ip", "legal", "contract", "nda"],
        response: "100% yours. Once the final payment is made, you own all the code, design assets, and intellectual property. We are also happy to sign an NDA before we start."
    },

    // --- Booking ---
    {
        category: "Booking",
        keywords: ["book", "call", "meeting", "consult", "chat", "talk", "calendar", "schedule"],
        response: "I'd love to chat more about your project. Let's find a time that works for you.",
        action: "OPEN_CALENDLY"
    },

    // --- Default / Greetings ---
    {
        category: "Greeting",
        keywords: ["hi", "hello", "hey", "greetings", "start"],
        response: "Hello there! I'm ready to answer your questions about our development services. What's on your mind?"
    }
];

export const fallbackResponse = "I'm not entirely sure about that specific detail, but I'd love to discuss it on a call. Shall we book a quick consultation?";
